const INITIAL_STATE = {
  registro: {},
  modoTela: "lista",
  lista: [],
  horarioValido: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "HORARIO_SOLICITACAO_HORA_EXTRA_MODO_TELA":
      return {
        ...state,
        modoTela: action.payload.modo,
        registro: action.payload.registro,
      };

    case "HORARIO_SOLICITACAO_HORA_EXTRA_LISTADO":
      return {
        ...state,
        lista: action.payload.data,
      };

    case "HORARIO_SOLICITACAO_VALIDADO":
      return {
        ...state,
        horarioValido: action.payload.data,
      };

    default:
      return state;
  }
};
